import TabStackLayout from '@/views/layouts/TabStackLayout'

export default function FormsLayout() {
  return <TabStackLayout title="表单" />
}
